import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';

var m=create(a);

export { m as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-HBQONQQE.mjs.map